import React from 'react';
import './FeatureStyles.css';

const AISuggestionsVideo = () => (
  <div className="feature-animation" style={{ outline: '1px solid #e5e7eb' }}>
    <video
      autoPlay
      loop
      muted
      playsInline
      style={{ filter: 'brightness(1.05)' }}
    >
      <source src="/suggestions.mp4" type="video/mp4" />
    </video>
  </div>
);

const AISuggestionsFeature = {
  icon: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
    </svg>
  ),
  title: "AI-Powered Test Suggestions",
  description: "One button, endless possibilities. Click 'Create from conversation' to instantly generate sad path tests, edge cases, or happy path scenarios. AI analyzes your interactions and proposes comprehensive test coverage - just click any suggestion to create it.",
  animation: <AISuggestionsVideo />
};

export default AISuggestionsFeature;
